import { shape, func } from 'prop-types';

export default shape({
    wishlist: shape({
        openModal: func,
    }),
    cacheManager: shape({
        addAvailableListener: func,
        addListenerAdd: func,
        addListenerRemove: func,
    }),
});
